export const NotFound = () => {
    return (
        <div className="center-full-page">
            <h1>Error 404</h1>
            <h5>We are sorry this page could not be found</h5>
        </div>
    );
}